import { MySvgIcon, MySvgIconProps } from './MySvgIcon'

type IconAppleProps = MySvgIconProps & {
  className?: string
  focusable?: boolean
  title?: string
}

export const IconApple = ({ ...props }: IconAppleProps) => (
  <MySvgIcon
    width="21px"
    height="21px"
    viewBox="0 0 20 26"
    version="1.1"
    title="Apple Icon"
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <g transform="translate(0.875626, 0.208978)">
        <g id="6-21-Apple">
          <path d="M7.54454589,7.50054558 C5.18740303,5.98149796 1.52073636,6.87197415 0.31597446,10.1719741 C-0.469739826,12.3195932 0.158831603,17.0338789 2.77787922,21.0148313 C4.24454589,23.2672122 6.18264113,24.9957837 7.02073636,24.8386408 C7.8588316,24.7338789 8.43502208,24.3148313 9.53502208,24.4719741 C10.2159745,24.5767361 10.1635935,24.5767361 11.0016887,24.9957837 C11.839784,25.4148313 13.5683554,24.629117 14.4064507,24.0005456 C15.2445459,23.3719741 18.9112126,16.8767361 18.2826411,12.6862599 C17.7588316,9.17673605 16.7635935,8.75768843 14.6159745,7.81483129 C12.4683554,6.87197415 11.2635935,7.71006939 10.2159745,8.28625986 C9.74454589,8.49578367 8.69692684,8.28625986 7.54454589,7.50054558" />
          <path d="M9.90168875,6.55768843 C9.32549827,5.09102177 9.79692684,3.5195932 7.38740303,1.89578367 C4.24454589,-0.251835375 1.88740303,0.0100693872 1.88740303,0.0100693872 L2.3588316,1.37197415 C2.3588316,1.37197415 2.30645065,1.84340272 5.18740303,3.99102177 C6.39216494,4.88149796 8.01597446,5.19578367 8.69692684,5.7195932 C9.48264113,6.24340272 9.90168875,6.55768843 9.90168875,6.55768843" />
          <path d="M8.9588316,9.49102177 C9.06359351,9.17673605 9.11597446,8.86245034 9.11597446,8.54816463 C9.32549827,6.9243551 9.16835541,5.14340272 10.1635935,3.20530748 C10.7921649,2.00054558 12.0493078,0.271974149 12.2064507,0.219593197 C12.4159745,0.167212244 12.2588316,0.586259863 12.7302602,1.4243551 C13.4112126,2.62911701 11.9445459,2.83864082 11.1588316,4.25292653 C10.0064507,6.40054558 9.9540697,8.0243551 9.84930779,9.33387891 C9.84930779,9.43864082 9.06359351,9.54340272 9.06359351,9.64816463" />
        </g>
      </g>
    </g>
  </MySvgIcon>
)
